import React, { useRef, useState } from "react";
import SearchFilterComponent from "../../filtering-component/search-filter-component";
import ApplyAdvanceFilterComponent from "../../filtering-component/hoa-advance-filter-option";

export default function PropertyTaskCompletedFilterComponent({
	option,
	fetchData,
	resetDataList,
}: any) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [options, setOptions] = useState(option || {});
	const buttonRef = useRef(null);

	const onChangeText = (event: any) => {
		const updatedOptions: any = { ...options };

		if (event?.date) {
			updatedOptions[event.date.key] = new Date(event.date.value).toLocaleString("en-US");
		} else if (event?.select) {
			updatedOptions[event.select.key] = event.select.value;
		} else if (event?.target?.name) {
			updatedOptions[event.target.name] = event.target.value;
		}

		setOptions(updatedOptions);
	};

	const onFilterKeyPress = (event: any) => {
		if (event.keyCode == 13) {
			resetDataList();
			fetchData(options);
		}
	};

	const onMoreFilterClick = (status: string) => {
		if (status === "Apply") {
			resetDataList();
			fetchData(options);
		} else if (status === "Clear") {
			resetDataList();
			fetchData({});
			setOptions({});
		} else {
		}
		setAnchorEl(null);
	};


	return (
		<main className="filtering-main-container">
			<div className="filtering-sub-container">
				<div className="filtering-container left">
					<span className="filtering-left-container-title">
						{"Properties Completed Task"}
					</span>
					<span className="filtering-left-container-subtitle">
						{"View & manage all the recently Completed properties Task"}
					</span>
				</div>
				<SearchFilterComponent
					tagType={"PropertyTask"}
					options={options}
					buttonRef={buttonRef}
					onChangeText={onChangeText}
					onFilterKeyPress={onFilterKeyPress}
					handleFilterClick={() => {
						setAnchorEl(buttonRef.current)
					}}
				/>
				<ApplyAdvanceFilterComponent
					anchorEl={anchorEl}
					setAnchorEl={setAnchorEl}
					onChangeText={onChangeText}
					onMoreFilterClick={onMoreFilterClick}
					options={options}
					tagType={"PropertyTask"}
				/>
			</div>
		</main>
	);
}
